<template>
  <div class="ts-space-y-4">
    <div class="row">
      <div class="col-md-7">
        <form class="form-horizontal ts-space-y-3">
          <div class="row">
            <label class="col-md-3 col-form-label ts-text-xs required ts-font-light">{{ $t('promotion.eventName')
            }}</label>
            <div class="col-md-8">
              <input v-model="model.promotion_name" type="text" class="form-control" />
              <div class="validate ts-text-xs" v-if="errors.has('promotion_name')">{{ errors.first('promotion_name')
              }}</div>
            </div>
          </div>
          <div class="row">
            <label class="col-md-3 col-form-label ts-text-xs required ts-font-light">{{ $t('promotion.startDate')
            }}</label>
            <div class="col-md-8">
              <a-date-picker v-model="model.promo_start_date" class="ts-w-full" format="DD-MM-YYYY"
                valueFormat="DD-MM-YYYY"></a-date-picker>
              <div class="validate ts-text-xs" v-if="errors.has('promo_start_date')">{{
                errors.first('promo_start_date') }}</div>
            </div>
          </div>
          <div class="row">
            <label class="col-md-3 col-form-label ts-text-xs"></label>
            <div class="col-md-8">
              <ts-checkbox v-model="model.is_no_end_date" class="ts-font-light"
                @change="() => model.promo_end_date = null">{{ $t('promotion.tillFurtherNotice') }}</ts-checkbox>
            </div>
          </div>
          <div class="row">
            <label class="col-md-3 col-form-label ts-text-xs ts-font-light"
              :class="!model.is_no_end_date ? 'required' : null">{{ $t('promotion.endDate') }}</label>
            <div class="col-md-8">
              <a-date-picker v-model="model.promo_end_date" :disabled="model.is_no_end_date" class="ts-w-full"
                format="DD-MM-YYYY" valueFormat="DD-MM-YYYY"></a-date-picker>
              <div class="validate ts-text-xs" v-if="errors.has('promo_end_date')">{{ errors.first('promo_end_date')
              }}</div>
            </div>
          </div>
        </form>
      </div>
      <div class="col-md-5">
        <div class="ts-w-10/12 ts-h-full ts-border ts-border-gray-300 ts-rounded-md ts-p-3">
          <BranchList v-model="model" />
          <div class="validate ts-text-xs" v-if="errors.has('branch_id_list')">{{ errors.first('branch_id_list') }}
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <ScheduleDay v-model="model" :validate="errors" />
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <PromotionPackage v-model="model" :validate="errors" />
        <div class="validate ts-text-xs" v-if="errors.has('condition')">
          {{ errors.first('condition') }}
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12 ts-flex ts-items-center ts-space-x-3 ts-justify-end">
        <ts-button @click.prevent="$router.push({ name: 'promotion' })">
          {{ $t('cancel') }}
        </ts-button>
        <ts-button v-if="!isEdit" color="primary" outline :waiting="loading" @click.prevent="onSaveAddNew">
          {{ $t('save_add_new') }}
        </ts-button>
        <ts-button v-if="!isEdit" :waiting="loading" @click.prevent="onSave" color="primary">
          {{ $t('save') }}
        </ts-button>
        <ts-button v-if="isEdit" color="primary" :waiting="loading" @click.prevent="onUpdate">
          {{ $t('update') }}
        </ts-button>
      </div>
    </div>
    <Spin size="large" fix v-if="loading"></Spin>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { Errors } from 'form-backend-validation'
import BranchList from './branch-list'
import PromotionPackage from './promotion-package/promotion-package.vue'
import ScheduleDay from './schedule_day'
import { isEmpty } from 'lodash'

export default {
  name: 'promotionPackageForm',
  components: {
    BranchList,
    PromotionPackage,
    ScheduleDay
  },
  data() {
    return {
      loading: false,
      errors: new Errors(),
      model: {
        promotion_name: '',
        promo_type_id: 9,
        is_no_end_date: false,
        promo_start_date: '',
        promo_end_date: '',
        branch_id_list: [],
        promo_schedule_list: [],
        package_list: [],
        condition: []
      }
    }
  },
  created() {
    this.createDay()
    this.getPreData({
      params: {},
      index: undefined
    })
  },
  computed: {
    ...mapState('promotion/promotionPackage', ['edit_data']),
    isEdit() {
      return !_.isEmpty(this.edit_data)
    },
  },
  methods: {
    ...mapActions('promotion/promotionPackage', ['getFormViewModel', 'store', 'update']),
    async getPreData({ params, index }) {
      this.loading = true
      await this.getFormViewModel({ index: index, params: params })
        .catch(error => {
          this.notice({ type: 'error', text: error.message })
        })
        .finally(() => (this.loading = false))
    },
    onSave() {
      this.loading = true
      this.errors = new Errors()
      this.store(this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.$router.push({ name: 'promotion' })
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.loading = false
        })
    },
    onSaveAddNew() {
      this.loading = true
      this.errors = new Errors()
      this.store(this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.clearInput()
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.loading = false
        })
    },
    onUpdate() {
      this.loading = true
      this.errors = new Errors()
      this.update({
        id: this.$route.params.id,
        data: this.model
      })
        .then(response => {
          this.$toasted.success(response.message)
          this.$router.push({ name: 'promotion' })
        })
        .catch(error => {
          this.$toasted.error(error.message)
          this.errors = new Errors(error.errors)
        })
        .finally(() => {
          this.loading = false
        })
    },
    createDay() {
      this.model.promo_schedule_list = []
      for (var i = 1; i <= 7; i++) {
        this.model.promo_schedule_list.push({
          day_id: null,
          time_from: null,
          time_to: null
        })
      }
    },
    setEditData() {
      if (!isEmpty(this.edit_data)) {
        this.model.promotion_name   = this.edit_data.promotion_name
        this.model.promo_type_id    = this.edit_data.promo_type_id
        this.model.is_no_end_date   = this.edit_data.is_no_end_date
        this.model.promo_start_date = this.edit_data.promo_start_date
        this.model.promo_end_date   = this.edit_data.promo_end_date
        this.model.branch_id_list   = this.edit_data.branches.map(el => el.branch_id)

        this.model.package_list = (this.edit_data.packages || []).map(pkg => ({
          package_id:            pkg.package_id,
          package_name:          pkg.package_name,
          currency_id:           pkg.currency_id,
          input_currency_id:     pkg.input_currency_id,
          fx_rate:               pkg.fx_rate,
          fx_rate_ratio:         pkg.fx_rate_ratio,
          sub_total:             pkg.sub_total,
          input_sub_total:       pkg.input_sub_total,
          discount_rate:         pkg.discount_rate,
          discount_type:         pkg.discount_type,
          discount_amount:       pkg.discount_amount,
          input_discount_amount: pkg.input_discount_amount,
          vat_rate:              pkg.vat_rate,
          vat_amount:            pkg.vat_amount,
          input_vat_amount:      pkg.input_vat_amount,
          grand_total:           pkg.grand_total,
          input_grand_total:     pkg.input_grand_total,
          details: (pkg.details || []).map(el => ({
            package_id:            el.package_id,
            package_detail_id:     el.package_detail_id,
            product_id:            el.product_id,
            uom_id:                el.uom_id,
            quantity:              el.quantity,
            currency_id:           el.currency_id,
            input_currency_id:     el.input_currency_id,
            fx_rate:               el.fx_rate,
            fx_rate_ratio:         el.fx_rate_ratio,
            unit_price:            el.unit_price,
            input_unit_price:      el.input_unit_price,
            sub_total:             el.sub_total,
            input_sub_total:       el.input_sub_total,
            discount_rate:         el.discount_rate,
            input_discount_rate:   el.input_discount_rate,
            discount_type:         el.discount_type,
            discount_amount:       el.discount_amount,
            input_discount_amount: el.input_discount_amount,
            vat_rate:              el.vat_rate,
            vat_amount:            el.vat_amount,
            input_vat_amount:      el.input_vat_amount,
            grand_total:           el.grand_total,
            input_grand_total:     el.input_grand_total,
            stock_out_quantity:    el.stock_out_quantity,
            order:                 el.order,
            // joined columns for display
            product_name_en:       el.product_name_en,
            product_name_kh:       el.product_name_kh,
            barcode:               el.barcode,
            pro_group_id:          el.pro_group_id,
            uom_name_en:           el.uom_name_en,
            uom_name_kh:           el.uom_name_kh,
          })),
        }))

        this.model.promo_schedule_list = []
        for (var i = 1; i <= 7; i++) {
          this.model.promo_schedule_list.push({
            day_id:   this.edit_data.schedules.filter(d => d.day_id == i).reduce((i, v) => i = v.day_id, null),
            time_from: this.edit_data.schedules.filter(d => d.day_id == i).reduce((i, v) => i = v.time_from, null),
            time_to:  this.edit_data.schedules.filter(d => d.day_id == i).reduce((i, v) => i = v.time_to, null),
            order: i
          })
        }
        this.model.promo_schedule_list = _.orderBy(this.model.promo_schedule_list, ['order'], ['asc'])
      }
    },
    clearInput() {
      this.model.promotion_name   = ''
      this.model.promo_type_id    = 9
      this.model.is_no_end_date   = false
      this.model.promo_start_date = ''
      this.model.promo_end_date   = ''
      this.model.branch_id_list   = []
      this.model.package_list     = []
      this.model.promo_schedule_list.forEach(element => {
        element.day_id    = null
        element.time_from = null
        element.time_to   = null
      })
    }
  }
}
</script>